"use client";

import { Note } from "@/graphql/schema";
import { EmptyState } from "./SearchPageEmptyStates";
import WithPreviewerContentSection from "../../components/styled/WithPreviewerPageContentSection";
import { Flex, FlexColumn } from "@/components/Flex";
import WithPreviewerContentGrid from "../../components/styled/WithPreviewerPageContentGrid";
import UserContentCard from "@/components/cards/UserContentCard/UserContentCard";
import SearchPagePagination from "./SearchPagePagination";
import PageSidePreviewer from "../../components/PageSidePreviewer";
import { usePublicProfiles } from "@/hooks/user/useUserData";

const NotesTabContent = ({ notes, totalPages }: { notes: Note[]; totalPages: number }) => {
    const usersIds = notes.map(note => note.userId);
    const { usersData } = usePublicProfiles(usersIds);

    if (!notes.length) {
        return <EmptyState />;
    }

    return (
        <WithPreviewerContentSection
            renderHeader={() => (
                <h2 style={{ fontSize: "1.7rem" }} data-testid="auto-id-fe7b21e7-f728-4051-90a4-e2b6410206dd">
                    Notes
                </h2>
            )}
            renderGrid={() => (
                <Flex style={{ gap: "2rem" }}>
                    <FlexColumn style={{ flex: 0.5 }}>
                        {/* NOTE GRID */}
                        <WithPreviewerContentGrid style={{ marginBottom: "4.1rem" }}>
                            {notes.map((note, i) => (
                                <UserContentCard
                                    key={note.noteId + i}
                                    note={note}
                                    ownerDetails={usersData[note.userId]}
                                />
                            ))}
                        </WithPreviewerContentGrid>

                        {/* NOTES TAB PAGINATION */}
                        <SearchPagePagination totalPages={totalPages} />
                    </FlexColumn>
                    <PageSidePreviewer initialNote={notes[0]} isNotesTab={true} isFlascardsTab={false} />
                </Flex>
            )}
        />
    );
};

export default NotesTabContent;
